import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Form, Button, message, 
    // Icon 
} from "antd";
// import { OrderedMap } from "immutable";
import {
    fieldGenerator,
    getErrorOnField,
    // getValidateStatus,
    submitForm
} from "utilities/form";
import "styles/form.css";
import { BANK_STATEMENT_ANALYSIS_FORM } from "constants/form-fields";
import moment from "moment";
const FormItem = Form.Item;
class BankStatementUploadFormPerfios extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    handleFormSubmit = submitForm.bind(this.props.form, () => null);

    state = {
        product_list: [],
        showForm: false
    };

    uploadDocuments = () => {
        const { form } = this.props;
        form.validateFields((err, values) => {
            if(!err){
                const fromDate = values.from_date ? moment(values.from_date, "YYYY-MM") : null;
                const toDate = values.to_date ? moment(values.to_date, "YYYY-MM") : null;
            
                if (fromDate && toDate && fromDate.isAfter(toDate)) {
                    message.error("From Date cannot be greater than To Date");
                    return;
                }
               this.props.onSubmit(values);
            }
        });
    }

    onRemove = _ => {
        if (this.props.form.getFieldValue("files")) {
            let files = this.props.form.getFieldValue("files").filter(file => file.uid !== _.uid);
            this.props.form.setFieldsValue({
                "files": files
            });
        } else {
            this.props.form.setFieldsValue({
                "files": null
            });
        }
    }

    beforeUpload = (_) => {
        let files = [];
        const existingFiles = this.props.form.getFieldValue("files");
        if (existingFiles) {
            files = [...existingFiles, _];
        } else {
            files.push(_);
        }
        this.props.form.setFieldsValue({
            "files": files
        });
        return false;
    }

    render() {
        return (
            <div className={"p-10"}>
                <Form
                    className={cx("form", "br-3")}
                >
                    <div className={"form-row"}>
                        {BANK_STATEMENT_ANALYSIS_FORM.map((field, fieldName) => {
                            if(fieldName === "files") {
                                field.beforeUpload = this.beforeUpload;
                                field.onRemove = this.onRemove;
                            }
                            if(fieldName === "password") {
                                let passwordProtectedVal = this.props.form.getFieldValue("password_protected");
                                if(passwordProtectedVal === "yes"){
                                    field.rules = [{
                                        required: true
                                    }];
                                    field.disabled = false;
                                }else{
                                    field.rules = [{
                                        required: false
                                    }];
                                    field.disabled = true;
                                }
                            }
                            if(fieldName === "bank_id") {
                                field.options = this.props.banks.map(_ => ({
                                    label: _.bank_name,
                                    value: _.id
                                }));
                            }
                            if(fieldName === "account_type") {
                                field.options = this.props.analysisTypeList && this.props.analysisTypeList.map((_, k) => ({
                                    label: k,
                                    value: _
                                })).toList().toArray();
                            }
                            return this.fieldGenerator(
                                fieldName,
                                field,
                                this.getErrorOnField(fieldName)
                            )();
                        }).toList()}
                    </div>
                    <div className="d-flex justify-content-flex-end">
                        <FormItem className={cx("mr-5")}>
                            <Button key="save" type="primary" icon={"plus"} onClick={this.uploadDocuments}>{"Save"}</Button>
                        </FormItem>
                    </div>
                </Form>
            </div>
        );
    }
}

BankStatementUploadFormPerfios.propTypes = {
    form: PropTypes.object,
    banks: PropTypes.array,
    onSubmit: PropTypes.func,
    analysisTypeList: PropTypes.object
};

export default Form.create({})(BankStatementUploadFormPerfios);